module.exports = __webpack_public_path__ + "static/img/master_studio_manage_1.befc685.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/master_studio_manage_1.png
// module id = pakx
// module chunks = 11